<template>
  <div>
    文章管理
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>